import { Box, Button, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import InputField from '../../../components/customElements/InputField/InputField'
import { isAdmin, isDealer } from '../../../services/AccountService'
import { MaintenanceOrder } from '../../ServiceReports/types/maintenance-reports.types'
import { useRequestReportActions } from './useRequestReportActions'

type RequestReportActionsProps = {
  request: MaintenanceOrder
  updateOrders?: any
  getServiceComments: (id: number) => void
  isRequestTable?: boolean
}

const RequestReportActions: FC<RequestReportActionsProps> = ({
  request,
  updateOrders,
  getServiceComments,
  isRequestTable,
}) => {
  const {
    deleteRequest,
    checkRequest,
    dealerEndClarification,
    comment,
    handleSetComment,
    handleClarifyServiceRequest,
  } = useRequestReportActions(request, updateOrders, getServiceComments)

  const isShownForAdmin =
    isAdmin() &&
    !isRequestTable &&
    request.status === 13 &&
    request.reportStatus === 2

  const isShownForDealer =
    isDealer() &&
    ((request.status === 14 &&
      request.reportStatus === 3 &&
      request.dataCheckingStatus === 2) ||
      ([6.2, 6.5].includes(request.status) && request.dataCheckingStatus === 2))

  return (
    <Stack spacing={'16px'} padding={'16px'}>
      {isShownForAdmin && request.dataCheckingStatus !== 2 && (
        <>
          <Box mt={2}>
            <InputField
              multiline
              value={comment}
              onChange={handleSetComment}
              rows={3}
              fullWidth
              placeholder={'Введите комментарий'}
              territorySelect={null}
            />
          </Box>
          <Button
            variant={'contained'}
            color={'primary'}
            fullWidth
            onClick={handleClarifyServiceRequest}
            disabled={!comment}
          >
            Уточнить данные
          </Button>
        </>
      )}
      {isShownForAdmin && request.dataCheckingStatus !== 1 && (
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          onClick={checkRequest}
        >
          Подтвердить
        </Button>
      )}
      {isShownForAdmin && (
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          onClick={deleteRequest}
        >
          Убрать заявку
        </Button>
      )}
      {isShownForDealer && (
        <>
          <Box mt={2}>
            <InputField
              multiline
              value={comment}
              onChange={handleSetComment}
              rows={3}
              fullWidth
              placeholder={'Введите комментарий'}
              territorySelect={null}
            />
          </Box>
          <Button
            variant={'contained'}
            color={'primary'}
            fullWidth
            onClick={dealerEndClarification}
          >
            Закончить уточнение заявки
          </Button>
        </>
      )}
    </Stack>
  )
}

export default observer(RequestReportActions)
